/**
 * متنِ کوچکِ بالای دکمه‌های کارتِ جستجو («اولین نوبت: …»، «پاسخ: …»، «آنلاین: …»).
 *
 * ستونِ هر دکمه روی موبایل حدود ۱۵۰ پیکسل جا دارد و متن باید همیشه **یک خط** و با یک قالب
 * باشد: «برچسب: <b>مقدار</b>». منبع‌ها (API، محاسبه‌ی خودِ کارت، حضورِ پزشک) هر کدام جمله‌ی
 * بلندِ خودشان را می‌سازند؛ این‌جا کوتاهشان می‌کنیم تا در آن عرض جا شوند.
 */

const WORD_NUMBERS: Record<string, string> = {
  یک: '۱',
  دو: '۲',
  سه: '۳',
  چهار: '۴',
  پنج: '۵',
  شش: '۶',
  هفت: '۷',
  هشت: '۸',
  نه: '۹',
  ده: '۱۰',
};

/** Global class (styled in PlasmicProductCard.module.css) for words hidden on narrow columns. */
export const TOP_TITLE_OPTIONAL_CLASS = 'top-title-optional';

export function compactTopTitle(html: string | null | undefined): string {
  if (!html) return html ?? '';

  return (
    String(html)
      // «حدود ۳ ساعت دیگر» → «۳ ساعت دیگر»
      .replace(/حدود\s+/g, '')
      // «کمتر از سه ساعت دیگر» → «تا ۳ ساعت دیگر»
      .replace(/کمتر از\s+(\S+)\s+(دقیقه|ساعت|روز)\s+دیگر/g, (_, n: string, unit: string) => `تا ${WORD_NUMBERS[n] ?? n} ${unit} دیگر`)
      // «اولین» is dropped by a container query when the column is too narrow (320px phones)
      .replace(/اولین\s+نوبت:/g, `<span class="${TOP_TITLE_OPTIONAL_CLASS}">اولین </span>نوبت:`)
  );
}

/** «حدود ۱۵ ساعت پیش آنلاین بوده» → «آنلاین: <b>۱۵ ساعت پیش</b>» */
export function formatLastSeenTopTitle(lastSeenHtmlSafe: string): string {
  const text = lastSeenHtmlSafe
    .replace(/حدود\s+/g, '')
    .replace(/\s*آنلاین بوده\s*$/, '')
    .trim();
  return `آنلاین: <b>${text}</b>`;
}
